export const verificationOptions = [
  {
    label: 'Spotify URL',
    value: 'spotify_url',
    placeholder: 'https://open.spotify.com/artist/example',
  },
  {
    label: 'Artist Bandcamp URL',
    value: 'bandcamp_url',
    placeholder: 'https://example.bandcamp.com/',
  },
  {
    label: 'Artist Apple Music URL',
    value: 'apple_music_url',
    placeholder: 'https://music.apple.com/us/artist/example/',
  },
  {
    label: 'Artist Tidal Music URL',
    value: 'tidal_music_url',
    placeholder: 'https://tidal.com/browse/artist/',
  },
  {
    label: 'Artist SoundCloud URL',
    value: 'soundcloud_url',
    placeholder: 'https://soundcloud.com/example',
  },
  {
    label: 'PRO - IPI number',
    value: 'ipi_number',
  },
  {
    label: 'YouTube channel URL',
    value: 'youtube_url',
  },
  {
    label: 'Twitter handle',
    value: 'twitter_handle',
  },
  {
    label: 'Instagram handle',
    value: 'instagram_handle',
  },
  {
    label: 'TikTok handle',
    value: 'tiktok_handle',
  },
  {
    label: 'Facebook page URL',
    value: 'facebook_url',
  },
  {
    label: 'Website URL',
    value: 'website_url',
  },
  {
    label: 'Other',
    value: 'other_description',
  },
]
export const getVerificationOptions = (
  exclude: string,
): {
  label: string
  value: string
  pattern?: string
}[] => {
  return verificationOptions.filter(({ value }) => value !== exclude)
}
export const artistProjectOptions = [
  {
    label: 'Artist',
    value: 'artist',
  },
  {
    label: 'Band',
    value: 'band',
  },
  {
    label: 'Producer',
    value: 'producer',
  },
  {
    label: 'Composer',
    value: 'composer',
  },
  {
    label: 'Engineer',
    value: 'engineer',
  },
  {
    label: 'Songwriter',
    value: 'songwriter',
  },
]
